import React from 'react';
import { Box } from '@mui/material';
import {
    FaChartBar,
    FaIdCard,
    FaMapMarkerAlt,
    FaUserFriends,
    FaHistory,
    FaBabyCarriage,
    FaBaby,
} from 'react-icons/fa'; 
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import ResultsWrapper from './Results';
import IdentificationWrapper from './Identification';
import OccurenceLocationWrapper from './OccurenceLocation';
import ParentsInfoWrapper from './ParentsInfo';
import BirthWrapper from './Birth';
import CurrentPregnancyWrapper from './CurrentPregnancy';
import PreviousPregnanciesWrapper from './PreviousPregnancies';

const menus = [
    {
        title: 'Resultados',
        path: '/governanceroom/dashboardvitalstatistics/live-births/results',
        icon: <FaChartBar style={{ marginRight: '5px' }} />
    },
    {
        title: 'Identificação',
        path: '/governanceroom/dashboardvitalstatistics/live-births/id',
        icon: <FaIdCard style={{ marginRight: '5px' }} />
    },
    {
        title: 'Local de Ocorrência',
        path: '/governanceroom/dashboardvitalstatistics/live-births/occurrence',
        icon: <FaMapMarkerAlt style={{ marginRight: '5px' }} />
    },
    {
        title: 'Informação dos Pais',
        path: '/governanceroom/dashboardvitalstatistics/live-births/parents-info',
        icon: <FaUserFriends style={{ marginRight: '5px' }} />
    },
    {
        title: 'Gestação Anterior',
        path: '/governanceroom/dashboardvitalstatistics/live-births/previous-pregnancies',
        icon: <FaHistory style={{ marginRight: '5px' }} />
    },
    {
        title: 'Gestação Atual',
        path: '/governanceroom/dashboardvitalstatistics/live-births/current-pregnancy',
        icon: <FaBabyCarriage style={{ marginRight: '5px' }} />
    },
    {
        title: 'Parto',
        path: '/governanceroom/dashboardvitalstatistics/live-births/birth',
        icon: <FaBaby style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardvitalstatistics/live-births/results':
        'Resultados Gerais do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/id': 'Resultados Gerais de Identificação do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/occurrence':
        'Resultados Gerais de Local de Ocorrência do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/parents-info':
        'Resultados Gerais de Informação dos Pais do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/previous-pregnancies':
        'Resultados Gerais das Gestações Anteriores do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/current-pregnancy':
        'Resultados Gerais da Gestação Atual do SINASC',
    '/governanceroom/dashboardvitalstatistics/live-births/birth': 'Resultados Gerais dos Partos do SINASC'
};

const LiveBirths = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardvitalstatistics');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="results" replace />}
                        />
                        <Route
                            path="results"
                            element={<ResultsWrapper />}
                        />
                        <Route
                            path="id"
                            element={<IdentificationWrapper />}
                        />
                        <Route
                            path="occurrence"
                            element={<OccurenceLocationWrapper />}
                        />
                        <Route
                            path="parents-info"
                            element={<ParentsInfoWrapper />}
                        />
                        <Route
                            path="previous-pregnancies"
                            element={<PreviousPregnanciesWrapper />}
                        />
                        <Route
                            path="current-pregnancy"
                            element={<CurrentPregnancyWrapper />}
                        />
                        <Route
                            path="birth"
                            element={<BirthWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default LiveBirths;
